import React, { useEffect, useRef } from 'react';
import ProductHeroLayout from './ProductHeroLayout';
import logo from '../../photos/logo.png';

function ProductHero() {
  const titleRef = useRef(null);
  const subtitleRef = useRef(null);
  const logoRef = useRef(null);

  useEffect(() => {
    const els = [logoRef.current, titleRef.current, subtitleRef.current];
    els.forEach((el, i) => {
      if (el) {
        el.style.opacity = '0';
        el.style.transform = 'translateY(30px)';
        setTimeout(() => {
          el.style.transition = 'all 0.8s cubic-bezier(0.4, 0, 0.2, 1)';
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
        }, 300 + i * 200);
      }
    });
  }, []);

  return (
    <ProductHeroLayout>
      <img
        ref={logoRef}
        src={logo}
        alt="The Hot Logistics"
        style={{
          width: '100%',
          maxWidth: 400,
          marginBottom: 32,
          filter: 'drop-shadow(0 0 40px rgba(22, 183, 36, 0.2))',
        }}
      />
      <h1 ref={titleRef} style={{
        fontSize: 'clamp(28px, 5vw, 52px)',
        fontWeight: 700,
        color: '#ffffff',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        lineHeight: 1.2,
        marginBottom: 20,
      }}>
        Транспортні рішення{' '}
        <span style={{
          background: 'linear-gradient(135deg, #16b724, #4dc247)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}>
          за межами
        </span>{' '}
        логістики
      </h1>
      <p ref={subtitleRef} style={{
        fontSize: 'clamp(16px, 2vw, 20px)',
        color: 'rgba(255,255,255,0.6)',
        maxWidth: 600,
        margin: '0 auto 40px',
        lineHeight: 1.6,
      }}>
        Надійний партнер у вантажоперевезеннях з 18-річним досвідом
      </p>
      <a href="tel:+380966341617" style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        padding: '16px 40px',
        background: 'linear-gradient(135deg, #16b724, #0e8a1a)',
        color: '#fff',
        fontSize: 16,
        fontWeight: 600,
        textDecoration: 'none',
        borderRadius: 50,
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        transition: 'all 0.3s ease',
        boxShadow: '0 4px 30px rgba(22, 183, 36, 0.4)',
      }}
      onMouseOver={e => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 8px 40px rgba(22, 183, 36, 0.5)';
      }}
      onMouseOut={e => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 4px 30px rgba(22, 183, 36, 0.4)';
      }}
      >
        Зателефонувати
      </a>
    </ProductHeroLayout>
  );
}

export default ProductHero;
